import { MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useStyles } from "../Header.styles";
import { useContext, useMemo } from "react";
import { MillNetworkDetailsContext } from "contexts/MillNetworkDetailsContext/MillNetworkDetailsContext";

export const RangeDropdown = () => {
    const classes = useStyles();
    const { rangeFilterOptions, rangeSelected, handleRangeSelection } = useContext(MillNetworkDetailsContext);

    const menuOptionComponents = useMemo(
        () =>
            rangeFilterOptions.map((option) => (
                <MenuItem key={option.id} value={option.id} className={classes.menuItem}>
                    {option.name}
                </MenuItem>
            )),
        [classes.menuItem, rangeFilterOptions],
    );

    return (
        <div className={classes.selectWrapper}>
            <Select
                IconComponent={KeyboardArrowDownIcon}
                className={classes.select}
                value={rangeSelected}
                onChange={handleRangeSelection}
            >
                {menuOptionComponents}
            </Select>
        </div>
    );
};
